import { render, staticRenderFns } from "./BaseUploadImage.vue?vue&type=template&id=0504aa54&scoped=true&"
import script from "./BaseUploadImage.vue?vue&type=script&lang=js&"
export * from "./BaseUploadImage.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&id=0504aa54&scoped=true&lang=css&"
import style1 from "./BaseUploadImage.vue?vue&type=style&index=1&id=0504aa54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504aa54",
  null
  
)

export default component.exports